import {
  SuperAdminDashboardData,
  PMODashboardData,
  ManagerDashboardData,
  EmployeeDashboardData,
} from '../types';
import apiClient from './apiClient';

/**
 * Dashboard API service
 * Uses real API endpoints — no mock fallback
 */
export const dashboardApi = {
  /**
   * Get Super Admin dashboard data
   */
  getSuperAdminDashboard: async (): Promise<SuperAdminDashboardData> => {
    return await apiClient.get<SuperAdminDashboardData>('/dashboard/admin');
  },

  /**
   * Get PMO dashboard data
   */
  getPMODashboard: async (): Promise<PMODashboardData> => {
    return await apiClient.get<PMODashboardData>('/dashboard/pmo');
  },

  /**
   * Get Manager dashboard data
   */
  getManagerDashboard: async (): Promise<ManagerDashboardData> => {
    return await apiClient.get<ManagerDashboardData>('/dashboard/manager');
  },

  /**
   * Get Employee dashboard data
   */
  getEmployeeDashboard: async (): Promise<EmployeeDashboardData> => {
    return await apiClient.get<EmployeeDashboardData>('/dashboard/employee');
  },
};

export default dashboardApi;
